enum BillingsTaxiUnbilledTransferredOrderListingSortKey {
  CONSUMER_ASC = "CONSUMER_ASC",
  CONSUMER_DESC = "CONSUMER_DESC",
  PRODUCER_ASC = "PRODUCER_ASC",
  PRODUCER_DESC = "PRODUCER_DESC",
}

export default BillingsTaxiUnbilledTransferredOrderListingSortKey;
